import { render, staticRenderFns } from "./BasicPieChart.vue?vue&type=template&id=37b7dfc6&scoped=true"
import script from "./BasicPieChart.vue?vue&type=script&lang=ts"
export * from "./BasicPieChart.vue?vue&type=script&lang=ts"
import style0 from "./BasicPieChart.vue?vue&type=style&index=0&id=37b7dfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7dfc6",
  null
  
)

export default component.exports